import { Component, OnInit } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { VisaManageService } from "src/app/core/services/visa-manage.service";
import { FilterModalComponent } from "../modal/filter-modal/filter-modal.component";
import {
  dataToSend,
  filteredData,
  searchItems,
} from "src/app/core/models/visa-management.model";
import { StorageService } from "src/app/core/services/storage.service";
import { debounceTime } from "rxjs";
import { CsvDownloadService } from "src/app/core/services/csv-download.service";
import { AccessManagementService } from "src/app/core/services/access-management.service";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute } from "@angular/router";
@Component({
  selector: "app-visa-process",
  templateUrl: "./visa-process.component.html",
  styleUrls: ["./visa-process.component.scss"],
})
export class VisaProcessComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  pageSize = 10;
  pageNumber: number = 1;
  filteredCheck: boolean = false;
  filterQueryParams: dataToSend;
  isHide: boolean = false;
  isAscend: boolean = true;
  dropDownItem: string = "";
  sortDate: string = "last";
  userList: any;
  expertListValue = [];
  isExpertLoading = [];
  filterMessage: string;
  searchFields: searchItems = {
    name: "",
    country: "",
    status: "",
    search: "",
    dropDownItem: "",
    choice: "consultant",
    sort: this.sortDate,
  };
  page_details: any = {
    count: 0,
    next: "",
    previous: "",
  };
  searchText: string = "";
  search = {
    name: "",
    country: "",
    category: "",
    app_date: "",
  };

  isLoading = false;
  processData: any = [];
  isPaid: boolean = true;
  isRefund: boolean = true;
  status: "PAID" | "UNPAID" | "REFUND_INITIATED" | "REFUND_COMPLETED" =
    "UNPAID";

  private readonly debounceTimeMs = 300;
  constructor(
    public activeModal: NgbActiveModal,
    private api: VisaManageService,
    private modalService: NgbModal,
    private storageService: StorageService,
    private csvDownloadService: CsvDownloadService,
    private accessManagementService: AccessManagementService,
    private toastr: ToastrService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Visa Management" },
      { label: "Process", active: true },
    ];
    this.getParams();
    // this.getProcessData(this.pageSize, 0);
    this.subscribeInlineEdit();
    this.getAllUsers();
  }

  getAllUsers() {
    this.accessManagementService
      .getUserListForVisaPro()
      .subscribe((res: any) => {
        this.userList = res;
      });
  }

  getParams() {
    this.route.queryParams.subscribe((params) => {
      const page = +params["page"];
      if (page) {
        this.pageNumber = page;
        let offset = this.pageSize * (page - 1);
        this.getProcessData(this.pageSize, offset);
      } else {
        this.getProcessData(this.pageSize, 0);
      }
    });
  }

  changeExpert(id, ind) {
    this.isExpertLoading[ind] = true;
    const type = "expert_edit";
    const data = {
      value: this.expertListValue[ind],
      tableData: {
        id: id,
      },
    };
    this.api.editFields(data, type).subscribe(
      (res) => {
        this.toastr.success("Expert updated successfully", "Success");
        this.isExpertLoading[ind] = false;
      },
      (err) => {
        this.isExpertLoading[ind] = false;
      }
    );
  }

  subscribeInlineEdit() {
    this.api.searchSubject
      .pipe(debounceTime(this.debounceTimeMs))
      .subscribe((searchValue) => {
        this.performEdit(searchValue);
      });
  }

  sortList() {
    this.isAscend = !this.isAscend;
    if (this.isAscend) {
      this.sortDate = "last";
    } else {
      this.sortDate = "first";
    }
    if (this.filterQueryParams) {
      this.filterQueryParams.sort = this.sortDate;
      this.getFilter(1);
    } else {
      this.getProcessData(this.pageSize, 0);
    }
  }

  getFilter(page) {
    this.api
      .getVisaFilterResult({
        ...this.filterQueryParams,
        limit: this.pageSize,
        offset: this.pageSize * (page - 1),
      })
      .subscribe((response) => {
        this.processData = response.results;
      });
  }
  nextPage(page) {
    if (this.filterQueryParams) {
      this.getFilter(page);
    } else {
      this.getProcessData(this.pageSize, this.pageSize * (page - 1));
    }
  }

  paidData() {
    this.status = "PAID";
    this.getProcessData(this.pageSize, 0);
  }

  unPaidData() {
    this.status = "UNPAID";
    this.getProcessData(this.pageSize, 0);
  }

  refundInitiatedData() {
    this.status = "REFUND_INITIATED";
    this.getProcessData(this.pageSize, 0);
  }

  refundCompletedData() {
    this.status = "REFUND_COMPLETED";
    this.getProcessData(this.pageSize, 0);
  }

  refundStatus(payment) {
    this.api.setRefund({ payment_id: payment }).subscribe((res) => {
      if (res) {
        this.toastr.success("Refund completed successfully", "Success");
        this.getProcessData(this.pageSize, 0);
      } else {
        this.toastr.error("Something went wrong", "Error");
      }
    });
  }

  changeVisaStatus(id: number, value: any) {
    const type = "Visa_Status";
    const data = {
      value: value.target.value,
      tableData: {
        id: id,
      },
    };
    this.api.editFields(data, type).subscribe((res) => {});
  }
  getProcessData(limit, offset) {
    if (this.filteredCheck) {
      this.getFilter(1);
      return;
    }
    let status = this.status;
    // let status;

    // if (this.isPaid) {
    //   status = "PAID";
    // } else {
    //   status = "UNPAID";
    // }

    // if (this.isRefund) {
    //   status = "REFUND_INITIATED";
    // } else if (this.isRefund === false) {
    //   status = "REFUND_COMPLETED";
    // }
    this.searchFields.country = "";
    this.searchFields.name = "";
    this.searchFields.dropDownItem = this.dropDownItem ? this.dropDownItem : "";
    this.searchFields.status = status;
    this.searchFields.search = this.searchText ? this.searchText : "";
    this.searchFields.sort = this.sortDate;

    this.api
      .customerVisaProcessDetails(limit, offset, this.searchFields)
      .subscribe((result: any) => {
        this.processData = result.results;
        this.processData.forEach((res, index) => {
          this.isExpertLoading[index] = false;
          this.expertListValue[index] = res?.experts_id;
        });
        this.setExapndedorNot();

        this.page_details = {
          count: result.count,
          next: result.next,
          previous: result.previous,
        };
      });
  }

  onChangeData(value: any) {
    this.api.searchSubject.next(value);
  }
  performEdit(value) {
    const type = "Inline";
    this.api.editFields(value, type).subscribe((res) => {});
  }
  searchVisaData() {
    this.filteredCheck = false;
    this.getProcessData(this.pageSize, 0);
  }

  resetData(event: any, type: string) {
    this.isHide = false;
    if (type === "search" && !event.target.value) {
      this.getProcessData(this.pageSize, 0);
    }
    if (type === "reset") {
      this.pageNumber = 1;
      this.dropDownItem = "";
      this.filterQueryParams = undefined;
      this.sortDate = "last";
      this.searchText = "";
      this.getProcessData(this.pageSize, 0);
    }
    this.filteredCheck = false;
  }

  downloadCsv() {
    const filteredData = this.storageService.getItem("filterData")
      ? this.storageService.getItem("filterData")
      : "";
    const data = {
      searchText: this.searchText,
      serachKey: this.dropDownItem,
      filteredOrNot: this.filteredCheck,
      filteredData: filteredData ? filteredData : "",
      status: this.isPaid ? "PAID" : "UNPAID",
      choice: "consultant",
    };
    this.api
      .downloadCSVFile(data, "/customer-visaprocess-details-csv/")
      .subscribe((result) => {
        const filename = "visa-process.csv";
        this.csvDownloadService.downloadCsv(result, filename);
      });
  }

  openFilterModal() {
    this.isHide = true;
    const modalRef = this.modalService.open(FilterModalComponent, {
      size: "l",
      centered: true,
      backdrop: "static",
    });
    modalRef.componentInstance.userList = this.userList;
    modalRef.componentInstance.pageSize = this.pageSize;
    modalRef.result.then((result: filteredData) => {
      if (result) {
        this.processData = [];
        this.processData = result?.response?.results;
        this.filterMessage = result?.filterMessage;
        this.filterQueryParams = result.queryParmas;

        this.page_details = {
          count: result.response.count,
          next: result.response.next,
          previous: result.response.previous,
        };
        this.filteredCheck = true;
      } else {
        this.filteredCheck = false;
        this.isHide = false;
      }
    });
  }

  setExapndedorNot() {
    this.processData.forEach((result) => (result.isExpanded = false));
  }
}
